import WalletTransactionCard from './WalletTransactionCard';
export default WalletTransactionCard;
